/* eslint no-console: off */

const images = document.querySelectorAll('.images img');
var zIndex = 5;

function getRandom(min, max) {
  return Math.random() * (max - min) + min;
}

function lazyLoad( img ){
  const dataSrcset = img.getAttribute('data-srcset')
  const srcset = img.getAttribute('srcset')
  if( !srcset ){
    img.setAttribute('srcset', dataSrcset)
  }
}

function fadeImages( img){
  var x = getRandom(30, 70)
  var y = getRandom(30, 70)
  var scale = getRandom(75, 100) / 100


  img.style.zIndex = zIndex++
  img.style.transform = ('translate(-'+x+'%, -'+y+'%) scale('+scale+')') 
  
  img.classList.add('is-visible')
  

  setTimeout( () => {
    img.classList.remove('is-visible')
  }, 8000)
}


setTimeout( () => {
  document.querySelector('body').classList.remove('wait')
  // document.querySelector('body').classList.add('ready')
}, 150);


setTimeout( () => {
  document.querySelector('svg').classList.add('shrink')

  images.forEach( (img, i) => {
    setTimeout( ()=>{
      lazyLoad( img )
    }, 1500 * i)
  });
}, 2000);




setTimeout( () => {
  images.forEach( (img, i) => {
    setTimeout( () => {
      fadeImages(img, i)

      setInterval( () => {
        fadeImages(img, i)
      }, 10000 );

    }, i * 2000);
  })
}, 3000);

